import injectSheet from 'react-jss'
import BulkUpload from './BulkUpload'
import styles from './BulkUpload.styles'

export default injectSheet(styles)(BulkUpload)
